import React, { useCallback } from 'react';

import { CustomInputInteface } from '../../core/models/inputs';

interface Props {
  children: JSX.Element;
  className?: string;
  onSubmit(): void;
  inputs: CustomInputInteface[];
}

function CustomForm({ children, className, onSubmit, inputs }: Props) {
  const validateForm = useCallback(
    (e: React.FormEvent) => {
      e.preventDefault();
      const errors: number[] = [];

      inputs.forEach((input) => {
        if (!input.isValid) {
          input.setShowError(true);
          errors.push(1);
        }
      });

      if (errors.length > 0) return;
      onSubmit();
    },
    [inputs],
  );

  return (
    <form className={className} onSubmit={validateForm}>
      {children}
    </form>
  );
}

export default CustomForm;
